// extracted by mini-css-extract-plugin
module.exports = {"rating":"ug-z","numberOfStars":"vg-z","count":"wg-z"};